export default __webpack_public_path__ + "static/hammer-febafbe4c602d5ca1c7564b3faa56d1b.svg";